import React from 'react';
import { useScratchpadContext } from '../../../ScratchpadContext';
import {
  IDeleteScratchpadNoteModalData,
  ModalSliceType,
  openModal,
} from '../../../../../redux/slices/modal';
import { useAppDispatch } from '../../../../../redux/hooks';
import ActionsMenu from '../../../../ActionsMenu/ActionsMenu';
import { SingleSelectOption } from '../../../../Dropdown/SingleSelect';

interface INoteActionsProps {
  noteId: string;
}

const NoteActions = ({ noteId }: INoteActionsProps) => {
  const { selectedScratchpad } = useScratchpadContext();
  const dispatch = useAppDispatch();

  const onDelete = () => {
    if (!selectedScratchpad) {
      return;
    }

    dispatch(
      openModal({
        type: ModalSliceType.DeleteScratchpadNote,
        data: {
          noteId,
          scratchpadId: selectedScratchpad,
        } satisfies IDeleteScratchpadNoteModalData,
      }),
    );
  };

  return (
    <ActionsMenu iconSize={16} placement="bottom-end">
      <SingleSelectOption
        iconName="trash"
        label={'Delete'}
        onClick={onDelete}
      />
    </ActionsMenu>
  );
};

export default NoteActions;
